(function () {
    'use strict';

    angular
        .module('elogbooksServices')
        .service('auditTrailLoader', AuditTrailLoader);

    AuditTrailLoader.$inject = ['$translate', '$http', '$injector', '$q', 'apiClient', 'API_URL'];

    function AuditTrailLoader($translate, $http, $injector, $q, apiClient, API_URL) {
        const createResourceState = () => ({
            loading: false,
            error: false
        });

        const createState = () => ({
            events: createResourceState(),
            messages: createResourceState(),
            files: createResourceState()
        });

        this.createState = createState;
        this.load = load;

        function load(options) {
            const state = options.state || createState();
            const resources = options.resources || {};
            const requests = [];
            const responses = {
                events: null,
                messages: null,
                files: null
            };

            angular.forEach(resources, function (resource, type) {
                if (!resource) {
                    return;
                }

                state[type] = state[type] || createResourceState();
                state[type].loading = false;
                state[type].error = false;

                if (resource.response) {
                    responses[type] = transform(resource.response, resource.transform);
                    return;
                }

                if (!resource.link) {
                    return;
                }

                state[type].loading = true;

                requests.push(
                    $http({
                        url: API_URL + resource.link,
                        method: 'GET',
                        params: { datagroup: 'details' }
                    }).then(function (response) {
                        responses[type] = transform(new apiClient.ResponseData(response.data), resource.transform);
                    }).catch(function (response) {
                        state[type].error = true;
                        reportAuditTrailLoadingError(type, resource.link, response, options);
                    }).finally(function () {
                        state[type].loading = false;
                    })
                );
            });

            return $q.all(requests).then(function () {
                return {
                    state: state,
                    responses: responses
                };
            });
        }

        function transform(response, transformFn) {
            if (!angular.isFunction(transformFn)) {
                return response;
            }

            return transformFn(response) || response;
        }

        function reportAuditTrailLoadingError(type, link, response, options) {
            const Sentry = getSentry();
            const responseData = response && response.data ? response.data : response || null;

            if (!Sentry) {
                console.error($translate.instant('AUDIT_TRAIL_LOAD_ERROR'), response);
                return;
            }

            Sentry.withScope(scope => {
                scope.setExtra('type', type);
                scope.setExtra('entityType', options.entityType || 'unknown');
                scope.setExtra('entityLink', options.entityLink || null);
                scope.setExtra('eventLink', options.resources && options.resources.events ? options.resources.events.link : null);
                scope.setExtra('messageLink', options.resources && options.resources.messages ? options.resources.messages.link : null);
                scope.setExtra('failedLink', link || null);
                scope.setExtra('status', response && response.status);
                scope.setContext('responseData', angular.isObject(responseData) && !angular.isArray(responseData) ? responseData : {
                    payload: JSON.stringify(responseData)
                });

                Sentry.captureMessage($translate.instant('AUDIT_TRAIL_LOAD_ERROR'), 'error');
            });
        }

        function getSentry() {
            try {
                return $injector.get('Sentry') || null;
            } catch (e) {
                return null;
            }
        }
    }
})();
